/**
 * <s-back-link> wraps a server-rendered fallback link. When the visitor arrived
 * from another page on this store, a click goes back in history instead, so the
 * link behaves like an app's back button. Without JavaScript, or when the visitor
 * landed here directly, the link follows its fallback href.
 */
class BackLink extends HTMLElement {
  #onClick = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let sameOrigin = false;
    try {
      sameOrigin = document.referrer !== '' && new URL(document.referrer).origin === window.location.origin;
    } catch {
      sameOrigin = false;
    }
    if (!sameOrigin || window.history.length < 2) return;
    event.preventDefault();
    window.history.back();
  };

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }
}

if (!customElements.get('s-back-link')) {
  customElements.define('s-back-link', BackLink);
}
